@file:OptIn(InternalResourceApi::class)

package top.features.auth.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/top.features.auth.generated.resources/"

@delegate:ResourceContentHash(-383_806_838)
internal val Res.drawable.login_bg: DrawableResource by lazy {
      DrawableResource("drawable:login_bg", setOf(
        ResourceItem(setOf(), "${MD}drawable/login_bg.jpg", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("login_bg", Res.drawable.login_bg)
}
